/**
 *
 * @param {SVGSVGElement} parent
 * @param {MainClassProps} main
 * @returns {DOMMatrix}
 */
const setPathMatrix = (parent, main) => {
  /** @type {DOMRect} */
  const bounds = parent.getBoundingClientRect();

  const scaleX = bounds.height / parent.viewBox.baseVal.height;
  const scaleY = bounds.width / parent.viewBox.baseVal.width;

  // TODO: make work with scale
  // main.svgPathReduceWidth = 0;
  // main.svgPathReduceHeight = 0;

  return parent.createSVGMatrix().scaleNonUniform(scaleX, scaleY);
};

export default setPathMatrix;
